export default {
  http_errors: {
    400: 'Something went wrong... please try again in a moment!',
    401: 'No permissions!',
    403: 'Something went wrong... please try again in a moment!',
    404: 'Something went wrong... please try again in a moment!',
    406: 'Incorrect payment details or validity has expired.',
    429: 'Too many requests. Please try again in a moment',
    500: 'A temporary problem with a redirect to a payment. Choose a different payment method or try again in a moment.',
    503: 'Server error. Please try again.',
    504: 'Waiting time exceeded, please try again.',
  },
  header: {
    language: 'Language',
  },
}


// WEBPACK FOOTER //
// ./src/lang/EN.js